import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { RegionService } from "../services";

export const useRegion = ()=> {
  return useQuery({
    queryKey: ["regions"],
    queryFn: RegionService.getAll,
  });
};
